import instance from "./instance";
import * as types from "../actions/actionTypes";

import { message } from "antd";
import i18n from "i18next";
import { TOGGLE_EDIT_INFO_PERMISSION } from "../actions/actionTypes";

export const getDrivers = () => {
  return async (dispatch) => {
    try {
      const res = await instance.get("drivers/");
      dispatch({
        type: types.GET_DRIVER,
        payload: res.data,
      });
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
};
export const clearDriverHistory = () => {
  return async (dispatch) => {
    dispatch({
      type: types.CLEAR_DRIVER_ORDER_HISTORY,
    });
  };
};
export const getDriverOrderHistory = (id, page = 1) => {
  return async (dispatch) => {
    try {
      const res = await instance.get(`drivers/${id}/orders?page=${page}/`);
      dispatch({
        type: types.GET_DRIVER_ORDER_HISTORY,
        payload: res.data,
      });
    } catch (error) {
      message.error(error.response.data.message);
      dispatch({
        type: types.GET_DRIVER_ORDER_HISTORY_ERROR,
        payload: error.response.data,
      });
    }
  };
};
export const deleteDriver = (id) => {
  return async (dispatch) => {
    try {
      await instance.delete(`drivers/${id}/`);
      message.success(i18n.t("Driver have been deleted successfully"));
      dispatch({
        type: types.DELETE_DRIVER,
        payload: id,
      });
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
};
export const toggleDriverStatus = (id) => {
  return async (dispatch) => {
    try {
      await instance.patch(`drivers/${id}/`);
      message.success(i18n.t("Driver status changed successfully"));
      dispatch({
        type: types.TOGGLE_DRIVER_STATUS,
        payload: id,
      });
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
};

export const toggleDriverAutoAssign = (id) => {
  return async (dispatch) => {
    try {
      await instance.patch(`drivers/${id}/toggle_auto_assign_orders/`);
      message.success(i18n.t("Driver auto assign changed successfully"));
      dispatch({
        type: types.TOGGLE_AUTO_ASSIGN_ORDERS,
        payload: id,
      });
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
};
export const toggleDriverEditInfoPermission = (id) => {
  return async (dispatch) => {
    try {
      await instance.patch(`drivers/${id}/toggle_edit_info_permission/`);
      message.success(i18n.t("Driver edit permission changed successfully"));
      dispatch({
        type: types.TOGGLE_EDIT_INFO_PERMISSION,
        payload: id,
      });
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
};

export const createDriver = (data, handleAddModalCancel) => {
  return async (dispatch) => {
    try {
      const res = await instance.post(`drivers/`, {
        username: data.username,
        password: data.password,
        first_name: data.first_name,
        last_name: data.last_name,
        phone_number: data.phone_number,
        vehicle_type: data.vehicle_type,
      });
      handleAddModalCancel();
      message.success(i18n.t("Driver have been added successfully"));
      dispatch({
        type: types.CREATE_DRIVER,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: types.CREATE_DRIVER_ERRORS,
        payload: error.response.data,
      });
    }
  };
};

export const editDriver = (data, handleAddModalCancel) => {
  return async (dispatch) => {
    try {
      const res = await instance.patch(`drivers/`, {
        driver_id: data.driver_id,
        username: data.username,
        password: data.password,
        first_name: data.first_name,
        last_name: data.last_name,
        phone_number: data.phone_number,
        vehicle_type: data.vehicle_type,
      });
      handleAddModalCancel();
      message.success(i18n.t("Driver have been edited successfully"));
      dispatch({
        type: types.EDIT_DRIVER,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: types.CREATE_DRIVER_ERRORS,
        payload: error.response.data,
      });
    }
  };
};

export const assignOrdertoDriver = (id, orderId,isB2B=false) => {
  return async (dispatch) => {
    try {
      await instance.patch(`drivers/${id}/orders/`, {
        order_id: orderId,
      });
      message.success(i18n.t("Driver changed successfully"));
      dispatch({
        type: isB2B ? "CHANGE_DRIVER_B2B":types.CHANGE_DRIVER,
        payload: {
          orderId: orderId,
          driverId: id,
        },
      });
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
};

export const changeProfilePicture = (response) => {
  return {
    type: types.CHANGE_DRIVER_PROFILE_PICTURE,
    payload: response,
  };
};
export const clearDriverError = () => {
  return {
    type: types.CLEAR_DRIVER_ERROR,
  };
};

export const fetchDriverCustomMessages = () => {
  return async (dispatch) => {
    try {
      let res = await instance.post("drivers/get_drivers_custom_messages/");
      dispatch({
        type: "FETCH_DRIVER_CUSTOM_MESSAGES",
        payload: res.data.data,
      });
    } catch (err) {
      message.error("SomethingWentWrong");
    }
  };
};

export const createDriverCustomMessage = (englishMessage, arabicMessage) => {
  return async (dispatch) => {
    try {
      const res = await instance.post(
        "drivers/create_drivers_custom_messages/",
        {
          englishMessage,
          arabicMessage,
        },
      );
      dispatch({ type: "ADD_DRIVER_CUSTOM_MESSAGE", payload: res.data.data });
      message.success("Added successfully");
    } catch (err) {
      message.error("SomethingWentWrong");
    }
  };
};

export const deleteDriverCustomMessage = (id) => {
  return async (dispatch) => {
    try {
      const res = await instance.post(
        "drivers/delete_drivers_custom_messages/",
        { id },
      );
      if (res.data.status === "success") {
        message.success("Successfully deleted");
        dispatch({ type: "DELETE_DRIVER_CUSTOM_MESSAGE", payload: id });
      }
    } catch (err) {
      message.error("SomethingWentWrong");
    }
  };
};

export const toggleDriverCustomMessage = (id) => {
  return async (dispatch) => {
    try {
      const res = await instance.post(
        "drivers/toggle_drivers_custom_messages/",
        { id },
      );
      if (res.data.status === "success") {
        message.success("Successfully deleted");
        dispatch({ type: "TOGGLE_DRIVER_CUSTOM_MESSAGE", payload: id });
      }
    } catch (err) {
      message.error("SomethingWentWrong");
    }
  };
};

